import React from 'react';
import { View, Text, Image, ScrollView } from 'react-native';
import { oStyles } from '../olonkho-styles';

export default function About({ navigation }) {
    return (
        <ScrollView style={ oStyles.about_container }>
            <Image source={ require('../../assets/logo.png') } style={ oStyles.about_image }/>
            <Text style={ oStyles.about_title }>О проекте</Text>
            <View style={ oStyles.about_content }>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Проект реализован коллективом Научно-исследовательского института Олонхо Северо-Восточного федерального университета имени М.К. Аммосова при финансовой поддержке российского государственного Фонда сохранения и изучения родных языков народов Российской Федерации в рамках «Конкурса по поддержке проектов, направленных на изучение родных языков народов Российской Федерации, в том числе в дистанционном формате» (2021 г.).</Text>
                </Text>
                <Text>
                    <Text>          </Text>
                    <Text style={ { 
                        fontFamily: 'times',
                        textAlign: 'justify'
                    } }>Целью проекта «Читаем, слушаем и изучаем якутский эпос олонхо» является разработка современного мобильного электронного приложения с расширенными возможностями для изучения родного языка и расширения словарного запаса. Продукт позволяет пользователю читать текст олонхо, при необходимости предоставляя определения непонятных, устаревающих слов; заниматься аудированием с двумя видами звукозаписей – традиционного исполнения олонхо (сказитель Ю.П. Борисов) и выразительного чтения текста олонхо (диктор М.Т. Сатанар). Последнее является важным преимуществом приложения, так как материал адаптирован для восприятия неподготовленного слушателя и пользователей с ограниченными зрительными возможностями. Дополнительно приложение содержит раздел практических занятий, направленных на укрепление полученных знаний в области родного языка.</Text>
                </Text>
            </View>
        </ScrollView>
      );
}